exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "label {\n\tfont-size: 10pt;\n\tfont-weight: normal;\n\tcolor: #444;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/equipment-user/equipment-user.component.css
// module id = 335
// module chunks = 0